// @flow

import React from 'react';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';

import SearchForm from './SearchForm';
import { CardsSlider, LodgeCard } from '../../../components';
import { SearchResults, ModifyOption, BestOption, AlternativeSearchResults, BestAlternativeOptions } from './SearchResults';

import { FlightPriceComparison, CoronaVirusNotice } from './StaticSections';
import { searchFlights } from '../../../redux/actions/FlightsUiActions';
import { SemiTransparentLoader, Page, WhitePanel } from '../../../components';
import SideBarReviews from '../../../components/ReviewsRatings/SideBarReviews';
import { injectFlightSearchParams } from '../Common';
import { useEffectOnFirstAndUpdateRender } from '../../../hooks';
import ReviewsRatingsContainer from '../../../redux/containers/ReviewsRatingsContainer';
import useFlightPageContext from '../static-db';

type Props = {
  searchFlights: (searchParams: Object) => void,
  queryParams: Object,
  location: { search: string },
  hasUserSearchedForFlights: boolean,
};

const FLIGHT_RATING_TITLES = ['Rating'];

function SearchAndResultsScreen(props: Props) {
  const [isLoading, setLoading] = React.useState(false);

  const {
    location: { search },
    searchFlights,
    queryParams,
    hasUserSearchedForFlights,
  } = props;

  async function fetchFlights() {
    setLoading(true);

    try {
      await searchFlights(queryParams);
    } finally {
      setLoading(false);
    }
  }

  useEffectOnFirstAndUpdateRender(() => {
    if (!queryParams || !queryParams.tripType || Object.keys(queryParams).length === 0) return false;

    const numKeysThereToSearch = Object.keys(queryParams).length;
    const numKeysRequiredToSearch =
      queryParams.tripType.toLowerCase() === 'o' ? 7 : 8;
    const flightReadyToBeFetched =
      numKeysThereToSearch === numKeysRequiredToSearch;

    if (flightReadyToBeFetched) fetchFlights();
  }, [search]);

  const { Faq, seo, lodge, Notice } = useFlightPageContext();
  const bgImage = 'url(https://honeyguide.s3.amazonaws.com/assets/lukla-airport.jpg)';

  return (
    <Page {...seo}>
      <SemiTransparentLoader
        isLoading={isLoading}
        loadingText="Searching for flights"
      />
      <div className="container-bg" style={{ backgroundImage: bgImage }}>
        <div className="container-content">
          <SearchForm></SearchForm>
          {/* <CoronaVirusNotice /> */}
        </div>
      </div>
      <Container className="pp">
        <Row>
          {/* <CoronaVirusNotice onMobile/> */}
          {/* <ul className="uvp">
            <li>
              <div className="uvp-blog">
              <img src="https://honeyguide.s3.amazonaws.com/assets/icons/happyCustomers.png" alt=""/>
              <p>1000+ Happy Trekkers</p>
              </div>
            </li>
            <li>
              <div className="uvp-blog">
              <img src="https://honeyguide.s3.amazonaws.com/assets/icons/247Support.png" alt=""/>
              <p>24/7 WhatsApp Support</p>
              </div>
            </li>
            <li>
              <div className="uvp-blog">
              <img src="https://honeyguide.s3.amazonaws.com/assets/icons/hgCredits.png" alt=""/>
              <p>Upto $9 Credit</p>
              </div>
            </li>
          </ul> */}

          {/* <SearchForm /> */}
          <Col xs="12">
            {hasUserSearchedForFlights && (
              <React.Fragment>
                <ModifyOption />
                <BestOption />
                <BestAlternativeOptions />
                <SearchResults />
                <AlternativeSearchResults />
              </React.Fragment>
            )}
          </Col>

          <Col lg="12">
            {Notice && <Notice />}
            {/* <ReviewsRatingsContainer
              origin="flights"
              ratingsTitles={FLIGHT_RATING_TITLES}
              isMobile={true}
            /> */}
            <WhitePanel>
              <h2>FAQ [Updated: 12 April, 2022]</h2>
              <Faq />
            </WhitePanel>
            {/* <ReviewsRatingsContainer
            origin="flights"
            ratingsTitles={FLIGHT_RATING_TITLES}
          /> */}
          </Col>

          {/* <SideBarReviews /> */}


          {/* <CoverageSection /> */}

          <FlightPriceComparison forMobile />


          {lodge && (
            <LazyLoad height={200} offset={100}>
              <CardsSlider
                title="Featured Lodges"
                endpoint={`lodgings/lodges?is_featured=1&region=${lodge.region
                  }`}
                Card={LodgeCard}
              />
            </LazyLoad>
          )}
        </Row>
      </Container>
    </Page>
  );

}

const mapStateToProps = ({ flights: { inbound, outbound } }) => ({
  hasUserSearchedForFlights: inbound !== null && outbound !== null,
});

export default connect(
  mapStateToProps,
  { searchFlights }
)(injectFlightSearchParams(SearchAndResultsScreen));



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchAndResultScreen.js